import { QueryFactory } from "../../../../Common";
export const QAcceptNewOffer = QueryFactory("AcceptCashOutBetNewOffer");
//# sourceMappingURL=QAcceptNewOffer.js.map